import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';
import { deleteProductURL, deleteBrandURL, addOrderURL, deleteOrderURL } from '../assets/constants/Urls/Url';

const AdminTable = ({ items: initialItems, type = '' }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState(initialItems || []);
  const [selectedItem, setSelectedItem] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  // Generate headers dynamically based on the first item's keys
  const headers = items && items.length > 0 ? Object.keys(items[0]) : [];

  // Capitalize type for display if it exists
  const displayType = type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Item';

  const handleDelete = (id) => {
    const confirmDelete = window.confirm(`Are you sure you want to delete this ${displayType.toLowerCase()}?`);
    if (!confirmDelete) return; // Cancel deletion if user clicks "Cancel"

    if (displayType === 'Product') {
      axios
        .delete(`${deleteProductURL}${id}`)
        .then(() => {
          setItems(items.filter((item) => item.id !== id));
        })
        .catch(() => {
          setError('Error deleting product');
        });
    } else if (displayType === 'Brand') {
      axios
        .delete(`${deleteBrandURL}${id}`)
        .then(() => {
          setItems(items.filter((item) => item.id !== id));
        })
        .catch(() => {
          setError('Error deleting brand');
        });
    }

    else if (displayType === 'Order') {
      axios
        .delete(`${deleteOrderURL}${id}`)
        .then(() => {
          setItems(items.filter((item) => item.id !== id));
        })
        .catch(() => {
          setError('Error deleting Order');
        });
    }

  };

  return (
    <>
      {items && items.length > 0 ? (
        <div className="admin-table-container" style={{background: 'var(--cardBackground, #222)', color: 'var(--textMain, gold)', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: '1.5em', margin: '1em 0'}}>
          <div className="row" style={{background: 'var(--cardBackground, #222)', color: 'var(--textMain, gold)'}}>
            <h2 className="admin-table-title col add" style={{color: 'var(--textHeading, #00C135)'}}>{displayType}</h2>
            <button
              onClick={() => navigate(`/admins/add-${type.toLowerCase()}`)}
              className="btn btn-primary col add"
              style={{background: 'linear-gradient(90deg, #00C135 60%, #FFD700 100%)', color: '#222', border: 'none', borderRadius: '8px', fontWeight: 600}}
            >
              Add {displayType}
            </button>
          </div>
          {error && <p className="text-danger">{error}</p>}
          <table className="admin-table" style={{background: 'var(--cardBackground, #fffbe6)', color: 'var(--textMain, #222)', borderRadius: '8px', width: '100%'}}>
            <thead>
              <tr>
                {headers.map((header) => (
                  <th key={header} style={{color: 'var(--textHeading, #00C135)', background: 'var(--cardBackground, #fffbe6)'}}>{header.charAt(0).toUpperCase() + header.slice(1)}</th>
                ))}
                <th style={{color: 'var(--textHeading, #00C135)', background: 'var(--cardBackground, #fffbe6)'}}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id} style={{background: 'var(--cardBackground, #fffbe6)', color: 'var(--textMain, #222)'}}>
                  {headers.map((header) => (
                    <td key={header}>{item[header]}</td>
                  ))}
                  <td className="actions">
                    {type === 'Order' ? (
                      <button
                        className="btn btn-edit"
                        style={{background: '#FFD700', color: '#222', borderRadius: '6px', marginRight: '0.5em'}} 
                        onClick={() =>  navigate('../invoice/'+item.Invoice)}
                      >
                        View
                      </button>
                    ) : ''}
                    <button
                      className="btn btn-edit"
                      style={{background: '#00C135', color: '#fff', borderRadius: '6px', marginRight: '0.5em'}} 
                      onClick={() =>  navigate('edit-product/'+item.id)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-delete"
                      style={{background: '#d32f2f', color: '#fff', borderRadius: '6px'}} 
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <button
          onClick={() => navigate(`/admins/add-${type.toLowerCase()}`)}
          className="btn btn-primary col add"
        >
          Add {displayType}
        </button>
      )}
    </>
  );
};

export default AdminTable;
